module.exports = __webpack_public_path__ + "56c137ecf7838dc34ff9c13a3ece9788.MP3";